module.exports = "/packs/media/images/MajorPurchase-6cf7bb0a59034564fc12fb2fa55daa69.png";